import React from "react";
import { Link } from "gatsby";
import { GetBlogPostData } from "components/ApiServices/GetBlogPostsdata";
import { getFullDate } from "../../../common/utils";
import { GatsbyImage } from "gatsby-plugin-image";

const Blogs2 = () => {
  const getBlogPosts = GetBlogPostData();

  return (
    <section className="blog-list section-padding sub-bg">
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <div className="head md-mb50">
              <p className="back-color sec-eyebrow">Get The Latest News</p>
              <h2 className="sec-title">What Our Trending News.</h2>
              <p>
                We provide company and finance service for startups and company
                business.
              </p>
              <Link
                to="/blog"
                onClick={() => {
                  checkPaceClass();
                }}
              >
                <span>More Blog Posts</span>
              </Link>
            </div>
          </div>
          <div className="col-lg-7 offset-lg-1">
            {getBlogPosts.slice(0, 3).map((val, i) => (
              <div key={i} className="item wow fadeInUp" data-wow-delay=".3s">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="img valign">
                      <Link
                        to={`/blog/${val?.slug}`}
                        onClick={() => {
                          checkPaceClass();
                        }}
                        aria-label={`${val?.title}`}
                      >
                        <GatsbyImage
                          style={{ width: "100", height: "100" }}
                          loading="lazy"
                          image={
                            val?.featuredImage?.node.localFile?.childImageSharp
                              ?.gatsbyImageData
                          }
                          className="img-responsive"
                          alt={`${val?.title}`}
                        />
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-8">
                    <div className="cont valign">
                      <div>
                        <div className="info">
                          <Link
                            to={`/blog/${val?.slug}`}
                            className="date"
                            onClick={() => {
                              checkPaceClass();
                            }}
                          >
                            <span>
                              <i>{getFullDate(val?.date)}</i>
                            </span>
                          </Link>
                          <span>/</span>
                          {val?.tags?.nodes?.slice(0, 1).map((tag, index) => (
                            <Link
                              onClick={() => {
                                checkPaceClass();
                              }}
                              key={index}
                              to={`/tag/${tag.slug}`}
                              className="tag"
                            >
                              <span>
                                {tag.name}
                                {val?.tags?.nodes.length !== index + 1
                                  ? ", "
                                  : ""}
                              </span>
                            </Link>
                          ))}
                        </div>
                        <h3 className="blog-post-title">
                          <Link
                            onClick={() => {
                              checkPaceClass();
                            }}
                            to={`/blog/${val?.slug}`}
                          >
                            {val?.title}
                          </Link>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* <div className="btn-more mt-30"><a className="simple-btn" href="/blogs/">Read More</a></div> */}
        </div>
      </div>
    </section>
  );
};

export default Blogs2;
